import { DisplayStatusToolTip } from '../../../../../../../../baseComponents/Displays/DisplayStatus'
import { RowData, TableData } from '../../../../../../../../baseComponents/TwinTable/types'
import { RectangularInputProps } from '../../../../../../../../forms/Input'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { InputTableLayoutData } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { Fragment } from 'react'
import CustomSelectWorkSheetProductStatus from '../../../../../WorkSheetLayout/CustomSelectWorkSheetProductStatus'
import ModalMatchProductWorkSheet from '../../../../../WorkSheetLayout/ModalsWorkSheetLayout/ModalMatchProductWorkSheet'
import useEditDeleteModal from '../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalWorkSheetSellTag from '../../../../../WorkSheetLayout/ModalsWorkSheetLayout/ModalWorkSheetSellTag'

export type WorkSheetProductStatusSelectorProps = RectangularInputProps & {
    workSheetProductStatuses: TwinDictionary
    allRowData: RowData
    updateDataURL: string
    setCompleteData: (value: React.SetStateAction<InputTableLayoutData | null>) => void
    readOnly?: boolean
    getCompleteData: (inputtable?: TableData) => Promise<void>
}
const WorkSheetProductStatusSelector: React.FC<WorkSheetProductStatusSelectorProps> = ({ workSheetProductStatuses, value, allRowData, updateDataURL, setCompleteData, readOnly, getCompleteData }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useWorkSheetProductStatusSelectorLogic()
    if (!workSheetProductStatuses) {
        return null
    }
    const myWorkSheetProductStatusId = parseInt(String(value))
    if (readOnly) {
        return <DisplayStatusToolTip text={workSheetProductStatuses?.[myWorkSheetProductStatusId]?.name || t('withoutStatus', 'Sin estado')} colorText={workSheetProductStatuses?.[myWorkSheetProductStatusId]?.color} className='w-full py-1' idTooltip={'workSheetProductStatus-' + allRowData?.id} />
    }
    return (
        <Fragment>
            <CustomSelectWorkSheetProductStatus {...{ workSheetProductStatuses, WorkSheetProductStatusId: myWorkSheetProductStatusId || 0, allRowData, updateDataURL, setCompleteData, getCompleteData, setOpenModal }} />
            {openModal?.type === 'delete' ? <ModalWorkSheetSellTag allRowData={openModal.allRowData} setOpenModal={setOpenModal} onSubmit={() => getCompleteData()} /> : null}
            {openModal?.type === 'edit' ? <ModalMatchProductWorkSheet groupProductByStatusURL={'/api/app/order/sell/workSheet/workSheetProduct/groupWorkSheetProduct'} allRowData={openModal.allRowData} setOpenModal={setOpenModal} getCompleteData={getCompleteData} /> : null}
        </Fragment>
    )
}

const useWorkSheetProductStatusSelectorLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return { openModal, setOpenModal }
}


export default WorkSheetProductStatusSelector